import { render, staticRenderFns } from "./PageTenders.vue?vue&type=template&id=f11946e4"
import script from "./PageTenders.vue?vue&type=script&lang=js"
export * from "./PageTenders.vue?vue&type=script&lang=js"
import style0 from "./PageTenders.vue?vue&type=style&index=0&id=f11946e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports